import { forwardRef, InputHTMLAttributes, ChangeEvent } from 'react';

export interface ToggleProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  checked: boolean;
  isDisabled?: boolean;
  label?: string;
  activeColor?: string;
  onChange?: (checked: boolean) => void;
}

/**
 * トグルスイッチコンポーネント
 */
const Toggle = forwardRef<HTMLInputElement, ToggleProps>(
  (
    {
      checked,
      onChange,
      isDisabled,
      label,
      activeColor = 'bg-kotomilThemaColor',
      className = '',
      ...props
    },
    ref,
  ) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.checked);
    };

    return (
      <div className="flex items-center">
        {label && <span className="text-sm font-medium mr-2">{label}</span>}
        <label className={`relative inline-block ${className}`}>
          <div
            className={`relative inline-block w-12 h-6 transition duration-200 ease-in-out rounded-full ${
              isDisabled ? 'cursor-not-allowed' : ''
            }`}
          >
            <input
              type="checkbox"
              className="absolute w-6 h-6 opacity-0"
              disabled={isDisabled}
              checked={checked}
              onChange={handleChange}
              ref={ref}
              {...props}
            />
            <span
              className={`block w-12 h-6 rounded-full transition-colors duration-200 ease-in-out ${
                checked ? activeColor : 'bg-gray-300'
              } ${isDisabled ? 'opacity-50' : ''}`}
            ></span>
            <span
              className={`absolute left-0 top-0 w-6 h-6 rounded-full transition-transform duration-200 ease-in-out bg-white border border-gray-300 transform ${
                checked ? 'translate-x-6' : 'translate-x-0'
              }`}
            ></span>
          </div>
        </label>
      </div>
    );
  },
);

Toggle.displayName = 'Toggle';

export { Toggle };
